import React from "react";
import HOC from "../../components/HOC";
import UserManagementComponents from "../../components/screen/userManagement/UserManagement";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const UserManagement = () => {
  return (
    <div className="">
      <PageTemplate
        header="User Management"
        mainComponent={
          <ThemeProvider theme={theme}>
            <div className="text-[12px]">
              <UserManagementComponents />
            </div>
          </ThemeProvider>
        }
        pageRole={6}
      />
    </div>
  );
};

export default HOC(UserManagement);
